import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import AutocompleteComponent from "../../components/CustomInputs/AutocompleteComponent";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { getAllVisitorType } from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";

export default function SelfRegistrationFilter(props) {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [purposeData, setPurposeData] = useState([]);
  const [visitorData, setVisitorData] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose1 = () => {
    setOpen(false);
  };

  const [payload, setPayload] = useState({
    purposeTypeId: "",
    visitorTypeId: "",
    visitMode: props.selectedObject,
    status: props.status,
  });

  const handleClose = () => {
    setPayload({
      purposeTypeId: "",
      visitorTypeId: "",
      visitMode: props.selectedObject,
      status: props.status,
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const [error, setError] = useState({
    purposeType: false,
  });

  const reset = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });

    setError({
      [name]: false,
    });
  };

  const handleSubmit = () => {
    if (
      payload.purposeTypeId.trim() === "" &&
      payload.visitorTypeId.trim() === ""
    ) {
      Toast(t("COMMON015"), "error");
      return;
    }

    props.applyFilter(payload);
    setPayload({
      purposeTypeId: "",
      visitorTypeId: "",
      visitMode: props.selectedObject,
    });
    handleClose();
  };
  if (open) {
    setDiaLogBoxBlur(true);
  }

  const loadData = () => {
    loadPurposeType();
    loadVisitorType();
  };

  const loadPurposeType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getPurposeType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPurposeData(data.data.purposeTypes);
        } else {
          setPurposeData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadVisitorType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setVisitorData(data.data.visitorTypes);
        } else {
          setVisitorData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event.id,
    });
  };

  const onselectVisitorType = (event) => {
    setPayload({
      ...payload,
      visitorTypeId: event.id,
    });
  };

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setOpen(true);
            loadData();
          }}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <SelfRegistrationFilter />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <SelfRegistrationFilter />
            </FilterIcon>
          )}
        </span>
      </Tooltip>
      <Grid item xs={6}>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={open}
          disableBackdropClick
          disableEscapeKeyDown
          BackdropProps={{
            style: {
              backdropFilter: "blur(5px)",
            },
          }}
        >
          <DialogTitle
            variant="h4"
            style={{ backgroundColor: darkMode ? "#0E2A41" : "" }}
          >
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 15,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            {/* {t('COMMON006')} */}
            <span
              style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
            >
              {t("COMMON006")}
            </span>
          </DialogTitle>
          <Divider
            variant="middle"
            style={{
              background: darkMode
                ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
                : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
              height: "1px",
              opacity: 0.5,
            }}
          />

          <DialogContent style={{ backgroundColor: darkMode ? "#0E2A41" : "" }}>
            <Grid container justifyContent="center" alignItems={"center"}>
              <Grid item xs={12} sm={10} sx={{ mt: 3 }}>
                <AutocompleteComponent
                  label={t("PURPOSETYPE")}
                  name="purposeTypeId"
                  value={payload.purposeTypeId}
                  onSelect={(e) => onselectPurposeType(e)}
                  options={purposeData}
                  onBlur={() => setError({ ...error, purposeTypeId: "" })}
                />
              </Grid>

              <Grid item xs={12} sm={10} sx={{ mt: 3 }}>
                <AutocompleteComponent
                  label={t("COMMON068")}
                  name="visitorTypeId"
                  value={payload.visitorTypeId}
                  onSelect={(e) => onselectVisitorType(e)}
                  options={visitorData}
                  onBlur={() => setError({ ...error, visitorTypeId: "" })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{
              justifyContent: "center",
              backgroundColor: darkMode ? "#0E2A41" : "",
            }}
          >
            <CancelButtons
              variant="contained"
              color="secondary"
              onClick={reset}
              sx={{
                paddingLeft: "10px",
                paddingRight: "10px",
                borderRadius: "40px !important",
                width: "150px",
                height: "42px",
              }}
            >
              <Typography variant="body1">{t("COMMON008")}</Typography>
            </CancelButtons>
            <SubmitButtons
              variant="contained"
              sx={{
                paddingLeft: "10px",
                paddingRight: "10px",
                borderRadius: "40px !important",
                width: "150px",
                height: "42px",
              }}
              onClick={handleSubmit}
            >
              <Typography variant="body1" style={{ textTransform: "none" }}>
                {t("COMMON024")}
              </Typography>
            </SubmitButtons>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
